import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import { themeSelector } from '@/state/config';
export const LoadingPage = () => {
    const { t } = useTranslation();
    const theme = useRecoilValue(themeSelector);
    return (_jsx("div", { className: "flex h-full w-full items-center justify-center text-foreground", children: _jsxs("div", { className: "text-center", children: [_jsx(LoadingIcon, { variant: theme === 'dark' ? 'light' : 'primary' }), _jsx("p", { children: t('common.loading') })] }) }));
};
